module.exports = __webpack_public_path__ + "img/11.7a2efd47.jpg";